<template>
    <table class="table bg-white table-bordered">
        <thead class="thead-light">
            <tr>
                <th scope="col" class="font-weight-bold"><h5></h5></th>
                <th scope="col" class="font-weight-bold">
                    <h6 class="table-head">{{ 'First File' | trans }}</h6>
                </th>
                <th scope="col" class="font-weight-bold">
                    <h6 class="table-head">{{ 'Second File' | trans }}</h6>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>
                    <span>{{ 'Name' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.firstFile.filename }}</span>
                </td>
                <td>
                    <span>{{ this.secondFile.filename }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Size' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.setFileSize(this.firstFile.size) }}</span>
                </td>
                <td>
                    <span> {{ this.setFileSize(this.secondFile.size) }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Height' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.firstFile.metadata.image_height }}px</span>
                </td>
                <td>
                    <span>{{ this.secondFile.metadata.image_height }}px</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Width' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.firstFile.metadata.image_width }}px</span>
                </td>
                <td>
                    <span>{{ this.secondFile.metadata.image_width }}px</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'File Type' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.firstFileType }}</span>
                </td>
                <td>
                    <span>{{ this.secondFileType }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { translate } from '../../../../../../../helper/translate';
import { formatting } from '../../../../../../../helper/formatting';

export default {
    name: 'MetaDataTable',
    methods: {
        setFileSize(size) {
            return formatting.fileSize(size);
        },
    },
    props: {
        firstFile: Object,
        secondFile: Object,
        firstFileType: String,
        secondFileType: String,
    },
    filters: {
        trans(msg) {
            return translate(msg);
        },
    },
};
</script>
<style></style>
